export const routes = {
  ChooseWorld: "/",
  CreateWorld: "/create",
  ShareWorld: "/w/:worldId/share",
  JoinWorld: "/w/:worldId/join", // password as hash
  Page: "/w/:worldId/:pageId",
};
